<!-- Terms & Conditions -->
@if (termsOnly.length > 0) {
  <div>
    <bp-switch
      [model]="groupModel"
      (valueChange)="onChange($event)"
      [disabled]="disabled"
      field="signed_terms_conditions">
      <span left>
        <span>{{ "agree_updated_terms_conditions" | translate }}</span>
        @for (t of termsOnly; track t; let i = $index) {
          <span>
            <!-- Item -->
            <a left target="_blank" [href]="t.getSource()">{{ t.getName() }}</a>
            <!-- Comma separator -->
            @if (i < termsOnly.length - 1) {
              <span>,</span>
            }
          </span>
        }
      </span>
    </bp-switch>
    <hr />
  </div>
}
<!-- Privacy Policies -->
@if (policiesOnly.length > 0) {
  <div>
    <bp-switch
      [model]="groupModel"
      (valueChange)="onChange($event)"
      [disabled]="disabled"
      field="signed_privacy_policies">
      <span left>
        <span>{{ "agree_updated_privacy_policies" | translate }}</span>
        @for (t of policiesOnly; track t; let i = $index) {
          <span>
            <!-- Item -->
            <a left target="_blank" [href]="t.getSource()">{{ t.getName() }}</a>
            <!-- Comma separator -->
            @if (i < policiesOnly.length - 1) {
              <span>,</span>
            }
          </span>
        }
      </span>
    </bp-switch>
  </div>
}
<!-- Others - if exist -->
@if (nonTermsOrPolicy.length > 0) {
  <div>
    <hr />
    @for (t of nonTermsOrPolicy; track t) {
      <bp-switch
        [model]="t"
        (valueChange)="onChange($event)"
        [disabled]="disabled"
        field="signed_by_user">
        <a left target="_blank" [href]="t.getSource()">{{ t.getName() }}</a>
      </bp-switch>
    }
  </div>
}
